import React from "react";
import { Link } from "react-router-dom";
import img from "../../images/watch.jpg";
import useReview from "../hooks/useReview";
import UserReview from "../userReview/userReview";
import "./Home.css";

const Home = () => {
  const [reviews] = useReview();
  const homeReview = reviews.slice(0, 3);
  return (
    <div>
      <div className="home-container">
        <div>
          <h1 className="name">
            Re<span className="watch-name">Watch</span>View
          </h1>
          <h3 className="web-title">
            Here you get the all new review about WATCH!
          </h3>
          <h3 className="web-title">
            let's enjoy the website and choose your favorite watch!
          </h3>
        </div>
        <div className="watch-img">
          <img src={img} alt="" />
        </div>
      </div>
      <div className="review">
        <h2 className="review-title">Customer Reviews</h2>
        <div className="review-container">
          {homeReview.map((review) => (
            <UserReview review={review}></UserReview>
          ))}
        </div>
      </div>
      <div className="btn-container">
        <Link to={"/review"}>
          <button className="review-btn">See All Reviews</button>
        </Link>
      </div>
    </div>
  );
};

export default Home;
